<template>
  <label class="flex cursor-pointer gap-x-2 px-3 py-1.5 hover:bg-p-50">
    <input
      :checked="value"
      type="checkbox"
      class="no-outline-on-click h-4 w-4 rounded text-p-500 shadow-none !ring-0"
      @input="$emit('input', ($event.target as HTMLInputElement).checked)"
      @change="$emit('change', data)"
    />
    <span class="cursor-pointer text-xs font-normal">
      {{ label }}
    </span>
  </label>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label: string
    data?: Record<string, any> | null
    value?: boolean
  }>(),
  {
    data: null,
    value: false,
  },
)

defineEmits(['input', 'change'])
</script>

<style scoped>
.no-outline-on-click:focus:not(:focus-visible) {
  @apply outline-none !important;
  @apply ring-0 !important;
}
</style>
